module.exports = __webpack_public_path__ + "img/qr-code.a42a3a36.png";